<template>
    <div class="mt-checkbox-list">
        <label class="mt-checkbox mt-checkbox-outline"> {{ label }}
            <input v-model="val" type="checkbox" :disabled="disabled"/>
            <span></span>
        </label>
    </div>
</template>

<script>

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Boolean, Number],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    checked: {
      type: [Number, Boolean],
      default: 0
    }
  },
  data () {
    return {
      val: null,
    }
  },
  watch : {
    val: function (value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.val = value
    },
    checked: function (value) {
      this.val = value
      this.$emit('input', value)
    }
  },
  mounted: function () {
    if (this.value) {
      this.val = this.value
    }

    this.$emit('input', this.value)
  },
}
</script>
